module.exports = __webpack_public_path__ + "img/magnifying-glass-tilted-right.e324a2cc.png";